import { AxiosResponse } from "axios";
import apiClient from "../apiClient/apiClient";
import { useQuery } from 'react-query';
import { ProductGroupType } from './productGroup.type';


export const useProductGroups = () => {
    return useQuery<AxiosResponse<ProductGroupType[]>>('productGroups', () => apiClient.get<ProductGroupType[]>('/product-groups'))
}